export const NOTIFICATION_PREFERENCES_COPY = {
	ALERTS_FOR_FOLLOWED_CHANGES: 'Alerts for Followed Metadata Changes',
	DAILY_SYNC_EMAIL: 'Daily Sync Email',
	EMAIL_WHEN_AT_MENTIONED: 'Email When @ Mentioned',
	SECTION_HEADER: 'Email Notifications'
};
